/* Umbrella Union — global queue player engine.
   One persistent bottom bar (#uu-pbar), one <audio data-uu-audio>.
   Reads a queue from #uu-hp-queue (JSON) if present, or via UU_PLAYER.setQueue().
   Any [data-uu-q="N"] element plays queue item N on click.
   Registers with the aa-media-coordinator for the global single-lock (audio + YouTube).
   2026-11-03: (1) a click that fails to start the song retries once by itself instead of needing more clicks;
   (2) the bar shows a "loading" pulse until sound starts; (3) the song carries over to the next page:
   it picks up where it left off, and if the browser won't start sound on its own, the bar waits paused there. */
(function () {
  'use strict';
  if (window.UU_PLAYER) return;
  var KEY = 'uu-player-state', MAX_AGE = 30 * 60 * 1000;
  var bar, audio, imgEl, titleEl, artistEl, linkEl, scrub, curEl, durEl, listEl, listBtn, posEl;
  var q = [], pageQ = null, idx = -1, ready = false, shuffleMode = false, retried = false, lastSave = 0;
  function $(id){ return document.getElementById(id); }
  function fmt(s){ s = Math.floor(s || 0); var m = Math.floor(s / 60), ss = s % 60; return m + ':' + (ss < 10 ? '0' : '') + ss; }
  function inList(el){ return !!(listEl && listEl.contains(el)); }

  function mark(){
    var playing = audio && !audio.paused;
    var loading = !!(bar && bar.classList.contains('is-loading'));
    document.querySelectorAll('[data-uu-q]').forEach(function (b) {
      // page buttons point at the page's own queue; only light them when that queue is the one playing
      var own = inList(b) || q === pageQ;
      var on = own && parseInt(b.getAttribute('data-uu-q'), 10) === idx;
      b.classList.toggle('is-active', on);
      b.classList.toggle('is-playing', on && playing);
      b.classList.toggle('is-loading', on && loading);
    });
  }
  function setLoading(on){ if (!bar) return; bar.classList.toggle('is-loading', !!on); mark(); }
  function syncMulti(){
    if (!bar) return;
    bar.classList.toggle('uu-pbar--multi', q.length > 1);
    if (posEl) posEl.textContent = (q.length > 1 && idx >= 0) ? ((idx + 1) + ' / ' + q.length) : '';
    if (q.length < 2) closeList();
  }
  function buildList(){
    if (!listEl) return;
    listEl.textContent = '';
    q.forEach(function (t, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'uu-pbar__item'; b.setAttribute('data-uu-q', i);
      var n = document.createElement('span'); n.className = 'uu-pbar__inum'; n.textContent = i + 1;
      var ti = document.createElement('span'); ti.className = 'uu-pbar__ititle'; ti.textContent = t.title || '';
      var ar = document.createElement('span'); ar.className = 'uu-pbar__iartist'; ar.textContent = t.artist || '';
      b.appendChild(n); b.appendChild(ti); b.appendChild(ar);
      listEl.appendChild(b);
    });
    mark();
  }
  function closeList(){ if (listEl && !listEl.hidden) { listEl.hidden = true; bar.classList.remove('uu-pbar--list'); if (listBtn) listBtn.setAttribute('aria-expanded', 'false'); } }
  function toggleList(){
    if (!listEl) return;
    if (listEl.hidden) { buildList(); listEl.hidden = false; bar.classList.add('uu-pbar--list'); if (listBtn) listBtn.setAttribute('aria-expanded', 'true'); }
    else closeList();
  }
  function load(i){
    if (!q.length) return;
    idx = ((i % q.length) + q.length) % q.length;
    var t = q[idx]; if (!t) return;
    bar.hidden = false; document.body.classList.add('uu-has-player');
    bar.classList.remove('uu-pbar--resume');
    if (imgEl) { imgEl.src = t.img || ''; imgEl.alt = t.title || ''; }
    if (titleEl) titleEl.textContent = t.title || '';
    if (artistEl) artistEl.textContent = t.artist || '';
    if (linkEl) linkEl.href = t.url || '#';
    if (t.src) { audio.src = t.src; retried = false; }
    if (scrub) scrub.value = 0;
    if (curEl) curEl.textContent = '0:00';
    syncMulti();
    mark();
  }
  // Start sound. If the browser refuses for any reason other than "needs a click", reload the file and try once more.
  function start(){
    if (!audio.src) return;
    bar.classList.remove('uu-pbar--resume');
    setLoading(true);
    var p;
    try { p = audio.play(); } catch (e) { p = null; }
    if (p && p.catch) p.catch(function (err) {
      if (err && err.name === 'NotAllowedError') { setLoading(false); bar.classList.add('uu-pbar--resume'); return; }
      if (!retried) { retried = true; try { audio.load(); var p2 = audio.play(); if (p2 && p2.catch) p2.catch(function () { setLoading(false); }); } catch (e) { setLoading(false); } }
      else setLoading(false);
    });
  }
  function play(i){
    if (i != null && i !== idx) load(i); else if (idx < 0) load(0);
    start();
  }
  function toggle(){
    if (idx < 0) { play(0); return; }
    if (audio.paused) start(); else audio.pause();
  }
  function next(){ if (shuffleMode && q.length > 1) { var n; do { n = Math.floor(Math.random() * q.length); } while (n === idx); play(n); } else { play(idx + 1); } }
  function shuffle(){ shuffleMode = true; if (!q.length) return; play(Math.floor(Math.random() * q.length)); }
  function prev(){ if (audio.currentTime > 3) audio.currentTime = 0; else play(idx - 1); }
  function usePageQueue(){ if (pageQ && q !== pageQ) { q = pageQ; idx = -1; syncMulti(); if (listEl && !listEl.hidden) buildList(); } }

  // ---- carry-over between pages (this tab only) ----
  function save(){
    try {
      if (idx < 0 || !q.length || bar.hidden) { sessionStorage.removeItem(KEY); return; }
      sessionStorage.setItem(KEY, JSON.stringify({ q: q, i: idx, t: audio.currentTime || 0, p: !audio.paused, s: shuffleMode, at: Date.now() }));
    } catch (e) {}
  }
  function forget(){ try { sessionStorage.removeItem(KEY); } catch (e) {} }
  function restore(){
    var st;
    try { st = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { st = null; }
    if (!st || !st.q || !st.q.length || st.i == null || !st.at || (Date.now() - st.at) > MAX_AGE) return;
    q = st.q; shuffleMode = !!st.s;
    load(st.i);
    if (!audio.src) return;
    var t = +st.t || 0;
    if (t > 0) {
      var seek = function () { audio.removeEventListener('loadedmetadata', seek); try { if (!audio.duration || t < audio.duration - 1) audio.currentTime = t; } catch (e) {} };
      audio.addEventListener('loadedmetadata', seek);
      if (curEl) curEl.textContent = fmt(t);
    }
    if (st.p) { start(); }
    else { audio.preload = 'metadata'; try { audio.load(); } catch (e) {} }
  }

  function init(){
    bar = $('uu-pbar'); if (!bar || ready) return; ready = true;
    audio = $('uu-pbar-audio'); imgEl = $('uu-pbar-img'); titleEl = $('uu-pbar-title');
    artistEl = $('uu-pbar-artist'); linkEl = $('uu-pbar-link'); scrub = $('uu-pbar-scrub');
    curEl = $('uu-pbar-cur'); durEl = $('uu-pbar-dur');
    listEl = $('uu-pbar-list'); listBtn = $('uu-pbar-list-btn'); posEl = $('uu-pbar-pos');
    var prevB = $('uu-pbar-prev'), nextB = $('uu-pbar-next'), ppB = $('uu-pbar-play'), closeB = $('uu-pbar-close');
    if (listBtn) listBtn.addEventListener('click', toggleList);
    if (listEl) listEl.addEventListener('click', function (e) { if (e.target.closest('[data-uu-q]')) setTimeout(closeList, 150); });
    if (prevB) prevB.addEventListener('click', prev);
    if (nextB) nextB.addEventListener('click', next);
    if (ppB) ppB.addEventListener('click', toggle);
    if (closeB) closeB.addEventListener('click', function () { audio.pause(); closeList(); bar.hidden = true; document.body.classList.remove('uu-has-player'); setLoading(false); forget(); });
    audio.addEventListener('timeupdate', function () {
      if (audio.duration) { if (scrub) scrub.value = (audio.currentTime / audio.duration) * 100; if (curEl) curEl.textContent = fmt(audio.currentTime); }
      if (durEl && audio.duration) durEl.textContent = fmt(audio.duration);
      var now = Date.now(); if (now - lastSave > 2000) { lastSave = now; save(); }
    });
    audio.addEventListener('loadedmetadata', function () { if (durEl && audio.duration) durEl.textContent = fmt(audio.duration); });
    audio.addEventListener('ended', next);
    audio.addEventListener('play', function () { bar.classList.add('is-playing'); bar.classList.remove('uu-pbar--resume'); mark(); save(); });
    audio.addEventListener('playing', function () { setLoading(false); });
    audio.addEventListener('pause', function () { bar.classList.remove('is-playing'); setLoading(false); save(); });
    audio.addEventListener('error', function () {
      if (!audio.src || audio.paused) { setLoading(false); return; }
      if (!retried) { retried = true; try { audio.load(); audio.play().catch(function () { setLoading(false); }); } catch (e) { setLoading(false); } }
      else setLoading(false);
    });
    if (scrub) scrub.addEventListener('input', function () { if (audio.duration) audio.currentTime = (scrub.value / 100) * audio.duration; });
    window.addEventListener('pagehide', save);

    // queue from page (home, release, artist pages)
    var qd = $('uu-hp-queue');
    if (qd) { try { pageQ = JSON.parse(qd.textContent) || null; } catch (e) {} }
    q = pageQ || [];

    // delegated play triggers
    document.addEventListener('click', function (e) {
      var sh = e.target.closest('[data-uu-shuffle]');
      if (sh) { e.preventDefault(); usePageQueue(); shuffle(); return; }
      var t = e.target.closest('[data-uu-q]');
      if (t) {
        e.preventDefault(); shuffleMode = false;
        if (!inList(t)) usePageQueue();
        play(parseInt(t.getAttribute('data-uu-q'), 10));
      }
    });

    // global single-lock
    try { var c = window.UmbrellaUnion && window.UmbrellaUnion.aaMediaCoordinator; if (c) c.registerSection('uu-global-player', { root: bar }); } catch (e) {}

    restore();
  }

  window.UU_PLAYER = {
    // a NEW queue invalidates the playhead position — without this, setQueue()+play(0) when idx
    // was already 0 skipped load() and kept the OLD audio playing (the Jul-6 crate-desync bug)
    setQueue: function (arr) { q = arr || []; pageQ = q; idx = -1; syncMulti(); if (listEl && !listEl.hidden) buildList(); mark(); },
    play: play, toggle: toggle, next: next, prev: prev, shuffle: shuffle,
    get index(){ return idx; }, get queue(){ return q; }
  };
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
})();
